export default __webpack_public_path__ + "static/media/card1.e13f6c51.jpg";